import { IconButton, MenuItem } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TimerIcon } from '@work4all/assets/icons/timer.svg';

import { useHistoryStack } from '@work4all/components/lib/navigation/history-stack';

import { AppParts, useCanView } from '@work4all/data';

import {
  ProjectTimeMask,
  ProjectTimeMaskInit,
} from '../../../../../../time-tracker/ProjectTimeMask';

import { BeforeMaskOpen } from './MaskOverlayTicketTimeTrack';

interface Props {
  init: ProjectTimeMaskInit;
  amplitudeEntryPoint: string;
  menuItemMode?: boolean;
  beforeMaskOpen?: () => Promise<BeforeMaskOpen>;
  disabled?: boolean;
}

export const MaskOverlayTimeTrack = (props: Props) => {
  const {
    init,
    amplitudeEntryPoint,
    menuItemMode = false,
    beforeMaskOpen,
    disabled,
  } = props;
  const { go } = useHistoryStack();
  const { t } = useTranslation();

  const canViewProjectTimeTracking = useCanView(AppParts.PROJECTTIMETRACKING);

  const handleOnClick = useCallback(async () => {
    const { ticketData, isValid } = await beforeMaskOpen();
    const modifiedInitData = {
      ...init,
      ticket: ticketData,
      customer: ticketData.businessPartner?.data,
    };

    if (isValid) {
      go({
        view: (
          <ProjectTimeMask
            init={modifiedInitData}
            amplitudeEntryPoint={amplitudeEntryPoint}
          />
        ),
        title: t('TIME_TRACKER.PROJECT_TIME'),
      });
    }
  }, [go, init, t, amplitudeEntryPoint, beforeMaskOpen]);

  if (!canViewProjectTimeTracking) {
    return null;
  }

  if (menuItemMode) {
    return (
      <MenuItem disabled={disabled} onClick={handleOnClick}>
        {t('TICKET.TRACK_TIME')}
      </MenuItem>
    );
  }

  return (
    <IconButton color="primary" onClick={handleOnClick} disabled={disabled}>
      <TimerIcon />
    </IconButton>
  );
};
